import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 24"
}, l = /* @__PURE__ */ e("path", {
  fill: "#0D141F",
  "fill-rule": "evenodd",
  d: "M11.332 4c0-.737.597-1.334 1.333-1.334H26a1.333 1.333 0 1 1 0 2.667H12.665a1.333 1.333 0 0 1-1.333-1.334M11.332 12c0-.737.597-1.334 1.333-1.334H26a1.333 1.333 0 0 1 0 2.667H12.665a1.333 1.333 0 0 1-1.333-1.334M11.332 20c0-.737.597-1.334 1.333-1.334H26a1.333 1.333 0 0 1 0 2.667H12.665a1.333 1.333 0 0 1-1.333-1.334",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  fill: "#6DE86A",
  d: "M9.797.627c.39.624.2 1.447-.424 1.837-1.031.644-2.06 2.052-2.883 3.49-.393.688-.709 1.33-.926 1.8-.084.176-.252.568-.326.741a1.334 1.334 0 0 1-2.42.123c-.23-.44-.604-.854-.962-1.178a9 9 0 0 0-.585-.466A1.333 1.333 0 0 1 2.728 4.74c.181.123.629.448.968.77q.217-.42.48-.88C5.02 3.151 6.323 1.225 7.96.203c.624-.39 1.447-.2 1.837.424M9.797 15.293c.39.624.2 1.447-.424 1.837-1.031.645-2.06 2.052-2.883 3.49a24 24 0 0 0-1.252 2.541 1.334 1.334 0 0 1-2.42.123c-.23-.44-.604-.854-.962-1.178a9 9 0 0 0-.585-.466 1.333 1.333 0 0 1 1.457-2.234c.181.123.629.448.968.77q.217-.42.48-.88c.844-1.479 2.148-3.405 3.784-4.427.624-.39 1.447-.2 1.837.424"
}, null, -1), a = [
  l,
  n
];
function s(d, r) {
  return c(), t("svg", o, [...a]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
